import {Quantity} from '@/model/Quantity';
import {QuantityUnit} from '@/model/QuantityUnit';

export default function(quantity: Quantity): string {
    const formatQuantityAsGrams = (value: number) => {
        if (value >= 1000) {
            return ((value / 1000) + '').replace('.', ',') + ' kg';
        }

        return `${value} g`;
    };

    if (!quantity) {
        return '';
    }

    let value = quantity.value;
    if (value === null || value === undefined) {
        return '';
    }

    if (quantity.unit as any === QuantityUnit.GRAMS) {
        return formatQuantityAsGrams(value);
    }

    return value + '';
}